// Thumbnail per content module, keyed by the checkbox name in
// combined_path/customization/views/customization.html (keep the two in sync).
// The tray resolves images here by slide id so no stored string reaches an img src.
export const SLIDE_IMAGE_CONFIG = new Map<string, string>([
  ["cost-of-emotional-investing", "/assets/images/challenge-placeholders/emotional_investing.png"],
  ["unpredictable-markets", "/assets/images/slideshow/shared/thumbnails/unpredictable_markets_thumb.png"],
  ["importance-diversification", "/assets/images/challenge-placeholders/importance_diversification.png"],
  ["market-expectations", "/assets/images/slideshow/shared/thumbnails/market_expectations_thumb.png"],
  ["investment-risk", "/assets/images/challenge-placeholders/investment_risk.png"],
  ["longer-retirement", "/assets/images/challenge-placeholders/longevity.png"],
  ["tax-strategies", "/assets/images/challenge-placeholders/tax_triangle.png"],
  ["taxable-and-deferred", "/assets/images/challenge-placeholders/tax_accumulation.png"],
  ["reducing-drag", "/assets/images/challenge-placeholders/tax_drag.png"],
  ["tax-efficient-rebalancing", "/assets/images/challenge-placeholders/auto_rebalancing.png"],
  ["qualified-and-non-qualified", "/assets/images/challenge-placeholders/qual_non_qual.png"],
  ["investments-goals", "/assets/images/challenge-placeholders/investments_support_goals.png"],
  ["dollar-cost-avg", "/assets/images/challenge-placeholders/dollar_cost_avg.png"],
  ["competitive-fees", "/assets/images/challenge-placeholders/flex_fees.png"],
  ["taking-withdrawals", "/assets/images/challenge-placeholders/taking_withdrawals.png"],
  ["guaranteed-income", "/assets/images/challenge-placeholders/income_through_annu.png"],
  ["standard-death-benefits", "/assets/images/challenge-placeholders/standard_db.png"],
  ["maximum-anniversary-value", "/assets/images/challenge-placeholders/MAV.png"],
  ["benefit-protector", "/assets/images/challenge-placeholders/benefit_protector.png"],
  ["enhanced-legacy", "/assets/images/challenge-placeholders/enhanced_leg.png"],
  ["mav-bp-combination", "/assets/images/challenge-placeholders/BP_with_MAV.png"],
  ["protect-your-spouse", "/assets/images/challenge-placeholders/protecting_spouse.png"],
  ["tax-efficient-beneficiaries-nonqualified", "/assets/images/challenge-placeholders/options_non_q.png"],
  ["pre-elect", "/assets/images/challenge-placeholders/pre_election.png"],
  ["tax-efficient-beneficiaries-qualified", "/assets/images/challenge-placeholders/options_q.png"],
]);
